<script setup lang="ts">
import { onMounted, onBeforeUnmount, ref } from 'vue';

interface Props {
  src: string;
  poster?: string;
  autoplay?: boolean;
  muted?: boolean;
  controls?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  autoplay: false,
  muted: false,
  controls: true,
});

const videoEl = ref<HTMLVideoElement | null>(null);
let hls: any = null;

onMounted(async () => {
  const video = videoEl.value;
  if (!video) return;

  if (video.canPlayType('application/vnd.apple.mpegurl')) {
    video.src = props.src;
    return;
  }

  const { default: Hls } = await import('hls.js');
  if (Hls.isSupported()) {
    hls = new Hls({ maxBufferLength: 60, backBufferLength: 30 });
    hls.loadSource(props.src);
    hls.attachMedia(video);
  }
});

onBeforeUnmount(() => {
  if (hls) {
    hls.destroy();
    hls = null;
  }
});
</script>

<template>
  <video
    ref="videoEl"
    :poster="poster"
    :autoplay="autoplay"
    :muted="muted"
    :controls="controls"
    playsinline
    preload="metadata"
    style="max-width: 100%; height: auto"
  />
</template>
